
import React from 'react';
import PropTypes from 'prop-types';
import { ErrorRounded, CheckCircleRounded } from '@material-ui/icons';
import { Fade } from '@mui/material';
import { withStyles } from '@material-ui/core/styles';
import { APEX_ACCEPTED_STATE, APEX_APPROVED_STATE, APPEAL_PENDING_STATE } from 'Consts/Apex';
import { CircularProgress } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

function CipStatusIcon({ status, loading, classes }) {
  if (loading) {
    return <CircularProgress test="cip-item-loader" className={classes.loader} size={24} />;
  }
  const Icon = () => {
    switch (status) {
      case APPEAL_PENDING_STATE: {
        return <ErrorRounded test="cip-item-verified-icon" className={classes.warning} />;
      }
      case APEX_APPROVED_STATE:
      case APEX_ACCEPTED_STATE: {
        return <CheckCircleRounded test="cip-item-verified-icon" className={classes.success} />;
      }
      case 'empty': {
        return <div className={classes.empty} />;
      }
      default: {
        return <ErrorRounded test="cip-item-error-icon" className={classes.error} />;
      }
    }
  };
  return (
    <Fade
      in={!loading}
      timeout={{
        enter: 800,
      }}
    >
      <div>
        <Icon />
      </div>
    </Fade>
  );
}
CipStatusIcon.defaultProps = {
  status: null,
};
CipStatusIcon.propTypes = {
  status: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
};
export default withStyles(theme => ({
  loader: {
  },
  empty: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  warning: {
    color: theme.palette.warning.main,
  },
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
}))(CipStatusIcon);
